function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Base from './base';
var UNGROUPED_ID = 0; // @namespace Model

var ParticipantGroup = /*#__PURE__*/function (_Base) {
  _inheritsLoose(ParticipantGroup, _Base);

  function ParticipantGroup() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = ParticipantGroup.prototype;

  _proto.urlRoot = function urlRoot() {
    return '/api/participant_groups';
  };

  _proto.isUngrouped = function isUngrouped() {
    return this.id === UNGROUPED_ID;
  };

  _proto.inviteUrl = function inviteUrl() {
    return this.get('invite_url');
  }
  /*
   * assign all participants from the passed
   * in Backbone.Collection that aren't
   * already in this group
   */
  ;

  _proto.assign = function assign(participants) {
    var _this = this;

    var add;

    if (participants === 'all') {
      add = 'all';
    } else {
      add = [];
      participants.each(function (participant) {
        if (!participant.groupIds().includes(_this.id)) {
          // prepare the participant to be added on the server
          add.push(participant.id); // add the participant to this group on the client

          participant.get('groups').add(_this);
        }
      });
    }

    if (add.length) {
      var data = {
        participants: {
          add: add
        }
      };
      this.save(data, {
        patch: true
      });
    }
  }
  /*
   * unassign all participants from the passed
   * in Backbone.Collection that aren't
   * already in this group
   */
  ;

  _proto.unassign = function unassign(participants) {
    var _this2 = this;

    var remove;

    if (participants === 'all') {
      remove = 'all';
    } else {
      remove = [];
      participants.each(function (participant) {
        if (participant.groupIds().includes(_this2.id)) {
          // prepare the participant to be removed on the server
          remove.push(participant.id); // remove the participant from this group on the client

          var participantGroups = participant.get('groups');
          var group = participantGroups.get(_this2);
          return participantGroups.remove(group);
        }
      });
    }

    if (remove.length) {
      var data = {
        participants: {
          remove: remove
        }
      };
      this.save(data, {
        patch: true
      });
    }
  };

  return ParticipantGroup;
}(Base);

export { ParticipantGroup as default };